// extracted by mini-css-extract-plugin
module.exports = {"title":"DashboardMySkeleton__title__11PN8"};